import { render, staticRenderFns } from "./archive_document.vue?vue&type=template&id=027e333c"
import script from "./archive_document.vue?vue&type=script&lang=js"
export * from "./archive_document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports